import api from '@/api'
import { jumpLink, addURLParam } from '@/utils/tool'
import store from '@/store'
import router from '@/router'
import { Toast } from 'vant'
import { ENV } from '@/config/env'

let authOnce = true

// 授权是否登录通用route.meta.login或者传入login来判断
export function authNeed({ route, next = () => {} }) {
  if (!['pocketInfirmarySystem','kangarooPhysicalSystem'].includes(sessionStorage.getItem('comefrom'))) {
    Toast.loading({
      message: '登录中...'
    })
  }
  const login = route.meta.login
  api.login
    .status({
      withoutLogin: false
    })
    .then((res) => {
      console.log(res, 'login.status')
      switch (res.code) {
        case 200:
          store.commit('user/SET_AUTH_STATUS', true)
          next()
          break
        case 510: // 没有用户信息，有微信授权信息
        case 513: // 既没有用户信息，也没有微信授权信息
          // toAuthAndLogin(route, res.data, res.code)
          toAuthAndLogin(route, res.code)
          break
        case 511:
          // 没有微信授权信息，跳转微信用户授权
          if (login) {
            // toAuthAndLogin(route, res.data, res.code)
            toAuthAndLogin(route, res.code)
          } else {
            next()
          }
          break
        default:
          next()
          break
      }
    })
    .finally(() => {
      Toast.clear()
    })
}
/* 去登录方法
 * 当接口返回510，且去登录时调这个方法，场景：收藏，加购，评论等
 * route 一般是当前页面route, 用于登录回跳地址
 * url 接口返回的登录地址 一般是res.data, 不传的话会自动去接口拿，由authNeed去走剩下流程
 */
export function toLogin(route, url) {
  let temp
  if (route) {
    temp = {
      ...route,
      meta: {
        login: true
      }
    }
  } else {
    // 没有路由时默认当前路由
    const curRoute = router.history.current
    temp = {
      ...curRoute,
      meta: {
        login: true
      }
    }
  }
  console.log(temp, 'temp')
  authNeed({
    route: temp
  })
  // 没有传url时去授权接口获取一下
  // if (!url) {
  //   authNeed({
  //     route: temp
  //   })
  // } else {
  //   toAuthAndLogin(temp, url)
  // }
}
export function toAuthAndLogin(route, code, afterAuthJumpLink) {
  // 开发环境账号登录手机号 16601126817
  if (process.env.NODE_ENV === 'development') {
    console.log(process.env.NODE_ENV, 'process.env.NODE_ENV')
    jumpLink({
      url: location.origin + '/#/login',
      replace: true
    })
    return
  }

  // 获取跳转的url

  // const beforeUrl = location.href.split('#')[0] + '#' + route.fullPath
  const beforeUrl = location.href.split('#')[0] + '#' + addURLParam(route.fullPath, 'jump_from_login', 1)

  // beforeUrl = encodeURIComponent(beforeUrl)
  // const bind_phone = route.meta.login ? 1 : 0

  const authUrl = 'api/frontend/central_auth/login'

  // 先移除bind_phone
  // let redirectUrl
  // if (!beforeUrl.includes('?bind_phone=')) {
  //   redirectUrl = beforeUrl + '?bind_phone=' + bind_phone
  // } else {
  //   redirectUrl = beforeUrl
  // }
  const redirectUrl = afterAuthJumpLink ?? beforeUrl
  // if (code === 511) {
  //   jumpLink({
  //     url: location.href.replace(/(\/#\/)(.+)/, '$1login') + '?redirect=' + encodeURIComponent(redirectUrl),
  //     replace: true
  //   })
  //   return
  // }
  console.log(code, redirectUrl, 'auth code')
  if ([510, 513].includes(code) && authOnce) {
    // 授权只触发一次
    authOnce = false
    // const isTijianMiniapp = store.state.userAgent === 'wechatMiniapp' && window.sessionStorage.getItem('channel') === '001_01_0001_0000_00'
    const isTijianMiniapp = store.state.userAgent === 'wechatMiniapp'
    const isPocketMiniapp = store.state.userAgent === 'pocketMiniapp'
    const url =
      isTijianMiniapp || isPocketMiniapp
        ? `${window.baseUrl}${authUrl}?redirect=` + encodeURIComponent(location.href)
        : `${window.baseUrl}${authUrl}?redirect=` + encodeURIComponent(redirectUrl)

    // const url = `${window.baseUrl}${authUrl}?redirect=` + encodeURIComponent(redirectUrl)
    console.log(url, '510url')
    jumpLink({
      url,
      replace: true
    })
    setTimeout(() => {
      authOnce = true
    }, 10000)
  } else if (code === 511) {
    const pathname = location.pathname.split('/health')[0]
    const jumpUrl =
      ENV === 'test'
        ? `${location.origin}${pathname}/api/frontend/cas/service/auth?redirect=` + encodeURIComponent(redirectUrl)
        : `${location.href.split('/health')[0]}/api/frontend/cas/service/auth?redirect=` + encodeURIComponent(redirectUrl)
    jumpLink({ url: jumpUrl, replace: true })
    // setTimeout(() => {
    // }, 3000)
  }
}
